// ===============================================================

// 👦 Livora Male Levels — Frontend (UI & Progress ONLY)

// ❌ لا علاقة له بسعر المكالمات

// ===============================================================



import i18n from "../i18n";



// ---------------------------------------------------------------

// سلم الترقية حسب مجموع الصرف

// ---------------------------------------------------------------

export const MALE_LEVEL_THRESHOLDS = [

  { level: 0, required: 0 },

  { level: 1, required: 100 },

  { level: 2, required: 1500 },

  { level: 3, required: 6000 },

  { level: 4, required: 15000 },

  { level: 5, required: 40000 },

  { level: 6, required: 100000 },

  { level: 7, required: 250000 },

  { level: 8, required: 700000 },

  { level: 9, required: 1800000 },

  { level: 10, required: 5000000 },

];



// ---------------------------------------------------------------

// helpers — names via i18n (lv0…lv10 in locale files)

// ---------------------------------------------------------------

export const getMaleLevelName = (level = 0) => {

  const n = Number(level);

  const safeLevel = Number.isFinite(n) ? n : 0;

  return String(

    i18n.t(`lv${safeLevel}`, {

      defaultValue: `Lv${safeLevel}`,

    })

  );

};



export const getMaleLevelList = () =>

  MALE_LEVEL_THRESHOLDS.map((t) => ({

    level: t.level,

    required: t.required,

    name: getMaleLevelName(t.level),

  }));



export const computeMaleLevelFromPoints = (points = 0) => {

  let lvl = 0;

  for (const t of MALE_LEVEL_THRESHOLDS) {

    if (Number(points) >= Number(t.required)) lvl = t.level;

  }

  return lvl;

};



export const getNextMaleLevelThreshold = (level = 0) =>

  MALE_LEVEL_THRESHOLDS.find((x) => x.level === level + 1) || null;



// ===============================================================

// 🔁 Backward compatibility (مهم جدًا)

// هذه الصادرات تُبقي الصفحات القديمة تعمل بدون تعديل

// ===============================================================



// ❌ السعر أُلغي لكن بعض الصفحات تستورده → نُبقيه فارغ

export const MALE_LEVELS = {};



// aliases للأسماء القديمة

export const computeLevelFromPoints = computeMaleLevelFromPoints;

export const getNextThreshold = getNextMaleLevelThreshold;


